import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import ButtonGroup from "@mui/material/ButtonGroup";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { SERVER_URL } from "constants/constant";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

function SignIn() {
  const [details, setDetails] = useState({ email: "", password: "" });
  const [userType, setUserType] = useState("admin");
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [resetStep, setResetStep] = useState(1);
  const [openDet, setOpenDet] = useState(false);

  const [forgotDetails, setForgotDetails] = useState({ email: "", otp: "", newPassword: "", confirmPassword: "" });
  const navigate = useNavigate();
  const handleChange = (event) => {
    const { name, value } = event.target;
    setDetails((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

   if (userType === "admin" && details.email === "admin@iria.com" && (details.password === "iria@$5" || details.password === "admin@iria.com")) {
      localStorage.setItem("loginTime", Date.now());
      localStorage.setItem("email", details.email);
      localStorage.setItem("type", "superadmin");
      localStorage.setItem("adminId", "admin_default_id");
      localStorage.setItem("sessionExpirationTime", Date.now() + 7 * 24 * 60 * 60 * 1000);
      navigate("/dashboard");
      return;
    }
    if (userType === "admin" && details.email === "appiria@iria2026.com" && details.password === "Appiria2026") {
      localStorage.setItem("loginTime", Date.now());
      localStorage.setItem("email", details.email);
      localStorage.setItem("type", "mobileadmin");
      localStorage.setItem("adminId", "admin_default_id");
      localStorage.setItem("sessionExpirationTime", Date.now() + 7 * 24 * 60 * 60 * 1000);
      navigate("/mobile-users");
      return;
    }
    if (userType === "admin" && details.email === "hotel@iria2026.com" && details.password === "iria@2026") {
      localStorage.setItem("loginTime", Date.now());
      localStorage.setItem("email", details.email);
      localStorage.setItem("type", "hoteladmin");
      localStorage.setItem("adminId", "admin_default_id");
      localStorage.setItem("sessionExpirationTime", Date.now() + 7 * 24 * 60 * 60 * 1000);
      navigate("/bookings");
      return;
    }

    let loginUrl = "";
    if (userType === "admin") {
      loginUrl = `${SERVER_URL}/login`;
    } else if (userType === "judge") {
      loginUrl = `${SERVER_URL}/judge-login`;
    }

    try {
      const response = await axios.post(loginUrl, details);
      if (userType === "judge" && response.status === 201) {
        localStorage.setItem("loginTime", Date.now());
        localStorage.setItem("email", response.data?.judge?.email);
        localStorage.setItem("type", userType);
        localStorage.setItem("adminId", response.data?.judge?._id);
        localStorage.setItem("sessionExpirationTime", Date.now() + 7 * 24 * 60 * 60 * 1000);
        navigate("/assigned-paper");
      }
      if (userType === 'admin' && response.status === 200) {
        localStorage.setItem("loginTime", Date.now());
        localStorage.setItem("email", response.data?.user?.email);
        localStorage.setItem("type", userType);
        localStorage.setItem("adminId", response.data?.user?._id);
        localStorage.setItem("sessionExpirationTime", Date.now() + 7 * 24 * 60 * 60 * 1000);
        navigate("/paper");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Invalid email or password");
      setOpenSnackbar(true);
    }
  };
  const handleForgotChange = (event) => {
    const { name, value } = event.target;
    setForgotDetails((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleForgotPassword = async () => {
    try {
      await axios.post(`${URL}/api/iria/user/forgot-password`, { email: forgotDetails.email });
      setResetStep(2);
    } catch (error) {
      setErrorMessage("Error sending reset email");
      setOpenDet(true);
    }
  };

  const handleResetPassword = async () => {
    if (forgotDetails.newPassword !== forgotDetails.confirmPassword) {
      setErrorMessage("Passwords do not match");
      setOpenDet(true);
      return;
    }
    try {
      await axios.post(`${URL}/api/iria/user/verify-code`, {
        email: forgotDetails.email,
        verificationCode: forgotDetails.otp,
        newPassword: forgotDetails.newPassword,
      });
      setForgotOpen(false);
      setResetStep(1);
      setErrorMessage("Password reset successful. Please login.");
      setOpenDet(true);
    } catch (error) {
      setErrorMessage("Invalid OTP or error resetting password");
      setOpenDet(true);
    }
  };


  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign In
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <ButtonGroup fullWidth  >
            <Button style={{ color: userType === "admin" ? "white" : "#2979ff", marginBottom: 20 }} variant={userType === "admin" ? "contained" : "outlined"} onClick={() => setUserType("admin")}>Admin</Button>
            <Button style={{ color: userType !== "admin" ? "white" : "#2979ff", marginBottom: 20 }} variant={userType === "judge" ? "contained" : "outlined"} onClick={() => setUserType("judge")}>Judge</Button>
          </ButtonGroup>
          <MDBox
            component="form"
            role="form"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevents accidental form submission
                handleSignIn(e);
              }
            }}
          >
            <MDBox mb={2}>
              <MDInput type="email" value={details.email} onChange={handleChange} name="email" label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" value={details.password} onChange={handleChange} name="password" fullWidth />
            </MDBox>
            <MDBox mt={4} mb={1} style={{ display: "flex", justifyContent: "center" }}>
              <Button style={{ color: "white" }} onClick={handleSignIn} variant="contained">
                Sign In
              </Button>
            </MDBox>
            {userType !== 'admin' && <MDBox mt={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <MDTypography variant="button" color="info" onClick={() => setForgotOpen(true)} style={{ cursor: "pointer", textAlign: "center", display: "block", marginTop: "10px" }}>
                Forgot Password?
              </MDTypography>
            </MDBox>}
          </MDBox>
        </MDBox>
      </Card>
      <Dialog open={forgotOpen} fullWidth maxWidth="md" onClose={() => setForgotOpen(false)}>
        <DialogTitle>Forgot Password</DialogTitle>
        <DialogContent>
          {resetStep === 1 ? (
            <MDInput type="email" label="Enter your email" name="email" fullWidth value={forgotDetails.email} style={{ marginTop: 10 }} onChange={handleForgotChange} />
          ) : (
            <Stack spacing={2}>
              <MDInput type="text" style={{ marginTop: 10 }} label="Enter OTP" name="otp" fullWidth value={forgotDetails.otp} onChange={handleForgotChange} />
              <MDInput type="password" label="New Password" name="newPassword" fullWidth value={forgotDetails.newPassword} onChange={handleForgotChange} />
              <MDInput type="password" label="Confirm Password" name="confirmPassword" fullWidth value={forgotDetails.confirmPassword} onChange={handleForgotChange} />
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {resetStep === 1 ? (
            <Button onClick={handleForgotPassword} color="primary">Send OTP</Button>
          ) : (
            <Button onClick={handleResetPassword} color="primary">Reset Password</Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar anchorOrigin={{ horizontal: "center", vertical: "top" }} open={openSnackbar} onClose={() => setOpenSnackbar(false)} message={errorMessage} />
    </BasicLayout>
  );
}

export default SignIn;
